module.exports = __webpack_public_path__ + "media/images/monthly8-8e189d9057022a11d6598c95946c29ef.jpg";